import { render, staticRenderFns } from "./SuggestionBar.vue?vue&type=template&id=6db62ce8&scoped=true&"
import script from "./SuggestionBar.vue?vue&type=script&lang=js&"
export * from "./SuggestionBar.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBar.vue?vue&type=style&index=0&id=6db62ce8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db62ce8",
  null
  
)

export default component.exports